export default {
  dialogMetadata: {
    formLabels: {
      allEmployees: 'All the employees',
      allSpecs: 'All the specializations',
      period: 'Select the assessment run period for which you want to get the upload:',
      dateFrom: 'from',
      dateTo: 'to',
      email: 'Specify the e-mail to which the link to download the file will be sent',
      addFields: 'Select additional fields to generate the report:',
      skillsType: 'Skills type',
      remove: 'Remove the schedule',
      set: 'Set the schedule',
      scoreCompleted: 'Score completed',
      roadmapCreated: 'IDM created',
      roadmapFixed: 'IDM fixed',
      roadmapCompleted: 'IDM completed',
      roadmapProgress: 'IDM progress %',
      overdueTasks: 'Overdue tasks',
      skill: 'Skill',
      evaluatedEval: 'Employee evaluation',
      supervisorEval: 'Supervisor evaluation',
      colleaguesEval: 'Colleagues evaluation',
      subordinatesEval: 'Subordinates evaluation',
      expertsEval: 'Experts evaluation',
      avgSkill: 'Average competence score',
      question: 'Indicator',
      avgQuestion: 'Average indicator score',
      approvalByEvaluated: 'Approved the environment by the employee',
      approvalBySupervisor: 'Approved the environment by the supervisor',
      selfScoreCompleted: 'Self score is completed',
      supervisorScoreCompleted: "Supervisor's score is completed",
      scoreProgress: 'progress of the score by all participants %',
      user: 'Executor',
      name: 'Name',
      description: 'Description',
      type: 'Type',
      curator: 'Supervisor/Curator',
      selfScore: 'Score the efficiency of reaching the target',
      employeeScore: 'Employee score',
      curatorScore: 'Supervisor/Curator score',
      comment: 'Comment by the result',
      file: 'or File',
      company: 'Company name',
      website: 'Company website',
      branch: 'Use your own profiles',
      clone: 'Clone shared profiles',
      link: 'Link name',
      employees: 'Select employee',
      allTeam: 'All team',
    },
    formPlaceholders: {
      employees: 'Search for employees by full name',
      specs: 'Search for specializations',
    },
    fileName: {
      fixedRoadmaps: 'Fixed_development_plans',
      roadmap: 'development_plan',
      pivotExport: 'Overall_average_scores_by_360',
      pivotTested: 'Export_progress_by_360',
      gradePivotExport: 'Team_statistics_by_360',
      usersGradePivotExport: 'Consolidated_report_by_360',
      scoreSkillsExport: 'Score_skills_by_360',
      passingExport: 'Passing_score_by_360',
    },
    titleTestSchedule: 'The test 360 schedule',
    fixedRoadmaps: 'Export fixed roadmaps to excel file',
    roadmap: 'Export the development map to excel file',
    pivotExport: 'Export overall average scores to excel file',
    pivotTested: 'Export progress by 360 to excel file',
    gradePivotExport: 'Export team statistics to excel file',
    usersGradePivotExport: 'Export consolidated report to excel file',
    scoreSkillsExport: 'Export the score of competencies to excel file',
    passingExport: 'Export passing the assessment to excel file',
    noEmployees: 'All employees have already been selected for the role of experts',
    inviteByEmailButton: 'Invite by e-mail',
    invitedByEmailTitle: 'Invited by e-mail',
    supervisorsTitle: 'Select supervisors',
    colleaguesTitle: 'Select colleagues',
    subordinatesTitle: 'Select subordinates',
    newTarget: 'New target',
    buttons: {
      addPortfolio: 'Add a portfolio item',
      deletePortfolio: 'Delete the portfolio item',
    },
    portfolio: 'Portfolio',
    deletePortfolio: 'Delete the portfolio item?',
    changeCompany: 'Change a company',
    changeSpecs: 'Change specializations',
    createCompany: 'Create a new company',
    editCompany: 'Edit the company',
    tooltips: {
      branch: 'A company with an independent but empty registry that is being filled from scratch',
      clone:
        'A company with an independent registry, but with a ready-made set of indicators, training materials and specializations that can be changed or used immediately',
      deleteNotification: 'Delete the notification',
      markAsRead: 'Mark as read',
    },
    uploadResearch: 'Upload research results to excel',
    logIn: 'Log in as another user',
    addSpecs: 'Add specializations',
    addSpecsDescription: 'First, specify the specialists, then select the specializations',
    selectSpecs: 'You can replace or add a specialization',
    unreadNotifications: 'New notifications',
    readNotifications: 'Read notifications',
    deleteAllNotifications: 'Delete all',
    readAllNotifications: 'Read all',
    unread: 'New',
    read: 'Read',
    // messages
    successMessages: {
      removePeriod: 'The schedule successfully removed',
      setPeriod: 'The schedule successfully set',
      sessionSettings: 'Test session settings changed successfully',
      createTarget: 'The new target successfully added',
      changeTarget: 'The target successfully changed',
      changeCurators: 'The supervisors/curators successfully changed',
      gradeTarget: 'The score successfully saved',
      moveTarget: 'The status of the target successfully changed',
      deleteTarget: 'The target successfully deleted',
      cancelTarget: 'The target successfully cancelled',
      createPortfolio: 'Portfolio successfully created',
      deletePortfolio: 'The portfolio item has been successfully deleted',
      changeCompany: 'Company successfully changed',
      changeSpecs: 'Specializations successfully changed',
      createCompany: 'The company has been successfully created',
      createLink: 'Successfully added',
      changeLink: 'Successfully changed',
      deleteLink: 'Successfully deleted',
      changeUser: 'Successfully! The page will be automatically reloaded...',
      selectSpecs: 'Specializations successfully selected',
      addSpecs: 'Specializations successfully added',
      acceptInvitation: 'Invitation accepted',
      rejectInvitation: 'Invitation rejected',
      changeSettings: 'The changes successfully saved',
    },
    errorMessages: {
      removePeriod: 'Failure to remove the schedule',
      setPeriod: 'Failure to set the schedule',
      exportFile: 'Failed to generate file',
      timeoutExpired:
        'Too much data. Please shorten the period or number of teams and repeat again.',
      sessionSettings: 'Failed to change test session settings',
      createTarget: 'Failed to add the target',
      changeTarget: 'Failed to change the target',
      changeCurators: 'Failed to change the supervisor/curators',
      gradeTarget: 'Failed to save the score',
      moveTarget: 'Failed to change the status of the target',
      deleteTarget: 'Failed to delete the target',
      cancelTarget: 'Failed to cancel the target',
      changeImage: 'Failed to upload image',
      createPortfolio: 'Failed to create a portfolio',
      deletePortfolio: 'Failed to delete portfolio item',
      changeCompany: 'Failed to change a company',
      changeSpecs: 'Failed to change specializations',
      createLogo: 'Failed to upload logo',
      changeLogo: 'Failed to change the logo',
      createCompany: 'Failed to create a company',
      changeDashboard: 'Failed to change the visibility of the blocks on the «My Profile» page',
      'ERROR:INN_CONFLICT': 'A company with such an TIN already exists',
      createLink: 'Failed to add link',
      changeLink: 'Failed to change link',
      deleteLink: 'Failed to delete link',
      changeUser: 'Failed to log in under another user',
      selectSpecs: 'Failed to select specializations',
      addSpecs: 'Failed to add specializations',
      acceptInvitation: 'Failed to accept the invitation',
      rejectInvitation: 'Failed to reject the invitation',
      changeNotification: 'Failed to mark as read the notification',
      changeNotifications: 'Failed to mark as read the notifications',
      deleteNotification: 'Failed to delete the notification',
      deleteNotifications: 'Failed to delete the notifications',
      getVariables: 'Failed to get the variables',
      getTemplate: 'Failed to get a preview of the email',
      getSettings: 'Failed to get the settings',
      changeSettings: 'Failed to save the changes',
    },
    infoMessages: {
      createTarget: {
        user: 'After creation, the target will be sent to the supervisor/curator for approval',
        curator: 'The target will be sent to the employee with the status «Approved»',
      },
      approveTarget:
        'The target has not been approved by the supervisor/curator yet, do you really want to approve?',
      exportFile:
        'The generation of the file may take some time. Please do not close the window and wait until the generated file is downloaded.',
      exportFileAsync:
        'The file will take some time to generate; once it is ready, you will receive an email with a link to download it.',
    },
    // dialogs
    expertsByEmailDialog: {
      supervisors: {
        title: 'Invite a supervisor by e-mail',
        deleteButton: 'Delete supervisor',
        addButton: 'Add supervisor',
      },
      colleagues: {
        title: 'Invite colleagues by e-mail',
        deleteButton: 'Delete colleague',
        addButton: 'Add colleague',
      },
      subordinates: {
        title: 'Invite subordinates by e-mail',
        deleteButton: 'Delete subordinate',
        addButton: 'Add subordinate',
      },
    },
    reEvalLockOfTests360Dialog: {
      subtitle: 'Here you can close or open testing sessions for users in created tests throughout',
      caption: {
        team: 'the current team',
        company: 'the company',
      },
      description:
        '<p>If you select the «Close all» option, then all tests created before the setup will not be available for replay, i.e. users will not be able to change their answers.</p><p>If you select the «Open all» option, then all tests created up to the time of configuration will be available for replay by the link from the letter, i.e. users will be able to change their answers as many times as they wish.</p>',
      confirmDialog: {
        open: {
          title: 'Open testing sessions?',
          text: 'All testing sessions will be open, users will be able to change their answers in the test using the link from the letter. Are you sure?',
          button: 'Yes, open',
        },
        close: {
          title: 'Close testing sessions?',
          text: 'All testing sessions will be closed, users will not be able to change their answers in the test. Are you sure?',
          button: 'Yes, close',
        },
      },
    },
    emailSettingsDialog: {
      title: {
        plural: 'Editing emails',
        single: 'Edit the email',
      },
      description: 'The changes will apply to all scores.',
      branding: {
        colorBtn: 'Button color',
        colorBtnText: 'The color of the text on the button',
      },
      formLabels: {
        subject: 'Subject',
        greeting: 'Greeting',
        text: 'Text',
        link: {
          title: 'Title',
          url: 'URL',
        },
      },
    },
    exportRoadmaps360Dialog: {
      title: {
        fixedRoadmaps: 'Export fixed roadmaps to excel file',
        massRoadmap: 'Export the development map to excel file',
      },
      formLabels: {
        allEmployees: 'All the employees',
        allSpecs: 'All the specializations',
        period: 'Select the assessment run period for which you want to get the upload:',
        email: 'Specify the e-mail to which the link to download the file will be sent',
        addFields: 'Select additional fields to generate the report:',
        skillsType: 'Skills type',
        scoreCompleted: 'Score completed',
        roadmapCreated: 'IDM created',
        roadmapFixed: 'IDM fixed',
        roadmapCompleted: 'IDM completed',
        roadmapProgress: 'IDM progress %',
        overdueTasks: 'Overdue tasks',
      },
      formPlaceholders: {
        employees: 'Search for employees by full name',
        specs: 'Search for specializations',
      },
      fileName: {
        fixedRoadmaps: 'Fixed_development_plans',
        massRoadmap: 'development_plan',
      },
    },
    addExpertGroupsTest360Dialog: {
      title: 'A new expert group',
      description: 'Any group changes will be applied to all assessments in this assignment',
      formLabels: {
        groups: 'Choose a group name',
      },
      formRules: {
        maxLength: "You can't add more than {count}",
      },
    },
    evaluatedGroupDialog: {
      title: 'Reference book of groups',
      subTitle: 'List of groups evaluating, available for launch in 360 assessment',
      noGroups: 'List of groups is empty, click on the «Add» button',
      labelSearch: 'Search by groups',
      successMessage: 'Group successfully added',
      errorMessage: 'Error adding group',
    },
    addEvaluatedGroupDialog: {
      title: 'New group',
      rules: {
        matchItem: 'Group with this name has been added to the directory before',
        maxLength: 'Length must not exceed 50 characters',
      },
      labelForm: 'Group name*',
      successMessage: 'Group successfully added',
      errorMessage: 'Error adding group',
    },
    inviteExpertsByEmailDialog: {
      title: 'Invite a participant by e-mail',
    },
    selectExpertsTest360Dialog: {
      noEmployees: 'All employees have already been selected for the role of experts',
      inviteByEmailButton: 'Invite by e-mail',
      invitedByEmailTitle: 'Invited by e-mail',
      title: 'List of participants of the «{name}» group',
    },
    selectEmployeesDialog: {
      title: 'Select employees',
    },
    createTargetDialog: {
      title: 'New target',
      formLabels: {
        user: 'Executor',
        name: 'Name',
        description: 'Description',
        type: 'Type',
        curator: 'Supervisor/Curator',
        selfScore: 'Score the efficiency of reaching the target',
        employeeScore: 'Employee score',
        curatorScore: 'Supervisor/Curator score',
        comment: 'Comment by the result',
      },
      tooltips: {
        saveForScoreStatus: 'To save the changes, you need to set a score',
        progress: 'Specify the percentage of the target completion in numeric format',
      },
    },
    createTeamReportDialog: {
      createReportDescription: {
        default: 'To create a team report, select a team from the list',
        tests360: 'To create a team report, set the required filters',
      },
      reportIsUnavailable: {
        tests360: 'There are no passed 360 tests to create a report',
        personal: 'There are no passed tests to create a report',
      },
      formLabels: {
        period: 'Assessment period',
        specialization: 'Select a specialization',
        employees: 'Select a participants',
        composition: 'Composition of the assessment',
      },
    },
    // confirm dialogs
    confirmDeleteTarget: {
      title: 'Delete the target?',
    },
    confirmCancelTarget: {
      title: 'Cancel the target?',
      button: 'Yes, cancel',
      buttonCancel: "Don't cancel",
    },
    //
  },
};
